import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { CreateProfileDropdownMenu } from '../../../../../../features/registration/profile/create-profile-dropdown-menu';
import { RegistrationProfilesTable, type RegistrationProfileTableHeaderProps } from '../../../../../../features/registration/profile/profiles-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/profile/_profile/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Registration,
      label: 'Profiles',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Registration>,
  head: () => getPageHead('Profiles'),
  component: ProfileList,
});

function TableHeader({ filter, search }: RegistrationProfileTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <RequiresAccess write>
              <CreateProfileDropdownMenu activator={<Button affixIcon={<PlusIcon aria-hidden />} size="small" />} />
            </RequiresAccess>
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.Registration}
      />

      {search}
    </VerticalStack>
  );
}

function ProfileList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RegistrationProfilesTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
